import React from 'react';
import { Link } from 'react-router';
import {
  Message,
  Section,
} from 'rebass';

import {
  PageHelmet,
} from 'frontend/components';

import config from 'frontend/config';

const TalentsCompare = () => (
  <div>
    <PageHelmet page="talents" />
    <Section pt={2} px={1}>
      <Message theme="warning" mt={4}>
        Talent Compare has been deprecated. Use Top Gear instead!
        &nbsp;
        <Link
          to="/simbot/topgear"
          href="/simbot/topgear"
          style={{
            color: config.colors.black,
            textDecoration: 'underline',
          }}
        >
          Go check it out &raquo;
        </Link>
      </Message>
    </Section>
  </div>
);

export default TalentsCompare;
